import React from 'react';
import { useTranslation } from 'react-i18next';

import type { CombinedFacet } from '../../utils/reselectors';

interface FilterFoldoutItemProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isActive?: boolean;
  facet: CombinedFacet;
}

const FilterFoldoutItem = ({ onClick, isActive, facet }: FilterFoldoutItemProps) => {
  const { t } = useTranslation('search');

  return (
    <li
      className={`filter-list-item${isActive ? ' is-active' : ''}${facet.title ? ' is-set' : ''}`}
    >
      <button
        type="button"
        className="filter-list-btn"
        onClick={onClick}
        title={t('Open the filter', { ns: 'search', name: facet.displayName })}
      >
        <div className="filter-list-btn-label">{facet.displayName}</div>
        <div className="filter-list-btn-meta">
          {facet.title && <div className="filter-list-btn-meta-value">{facet.title}</div>}
          <div className="filter-list-btn-meta-icon">
            <i className="icon-chevron-right no-margin" />
          </div>
        </div>
      </button>
    </li>
  );
};

export default FilterFoldoutItem;
